module.exports = __webpack_public_path__ + "img/pitch-events-banner-1900X595.4c005dcf.png";